var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('product-list',{staticStyle:{"zoom":"0.85"},attrs:{"page":"exhibition"},on:{"productItems":_vm.productItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }